export const worldMapRenamingMapper = {
	'Antigua and Barbuda': 'Antigua & Barbuda',
	'Democratic Republic of the Congo': 'DR Congo',
	'Faroe Islands': 'Faroes',
	'Guinea-Bissau': 'Guinea Bissau',
	Ireland: 'Republic of Ireland',
	'Ivory Coast': 'Côte d’Ivoire',
	'North Macedonia': 'Macedonia',
	Palestine: 'Palestinian territories',
	'Trinidad and Tobago': 'Trinidad & Tobago',
	'Turks and Caicos Islands': 'Turks and Caicos',
	'United States': 'USA'
};
